<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="2" rx="0.5" fill="#152E39"/>
    <rect x="2" y="11" width="14" height="2" rx="0.5" fill="#152E39"/>
    <rect x="2" y="19" width="20" height="2" rx="0.5" fill="#152E39"/>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
